module.exports = __webpack_public_path__ + "img/volvik_logo.18653053.png";